import { render, staticRenderFns } from "./addBlogToExtract.vue?vue&type=template&id=3336ab18&"
import script from "./addBlogToExtract.vue?vue&type=script&lang=js&"
export * from "./addBlogToExtract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports